<template>
  <div class="p-5">
    <ImageComponent @add-image="handleAddImage($event)" />
    <ApprovalComponent @submit-data="handleData($event)" :datas="datas" />

    <div class="container-fluid">
      <div class="row size-column">
        <div class="col-xxl-12 col-md-12 box-col-12 grid-ed-12">
          <div class="row">
            <LastUpdated :tableData="myTableData" :tableColumns="myTableColumns" :buttons="buttons" @click="handleClick"
              :getClass="getClass" :blockStatus="blockStatus" :lastUpdated="lastUpdated" />

            <div class="col-sm-12 col-lg-12 col-xl-12 mb-5" style="border-bottom: 2px solid rgb(216, 215, 215)"></div>
            <h3 class="flex-grow-1 speedee-bold p-2">About Us</h3>
            <ul class="nav nav-tabs m-b-20" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="main-tab" data-bs-toggle="tab" data-bs-target="#main" type="button"
                  role="tab" aria-controls="main" aria-selected="true">
                  Main
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="about-tab" data-bs-toggle="tab" data-bs-target="#about" type="button"
                  role="tab" aria-controls="about" aria-selected="true">
                  About Us
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="history-tab" data-bs-toggle="tab" data-bs-target="#history" type="button"
                  role="tab" aria-controls="history" aria-selected="true">
                  History
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="milestone-tab" data-bs-toggle="tab" data-bs-target="#milestone" type="button"
                  role="tab" aria-controls="milestone" aria-selected="true">
                  Corporate Milestone
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="mission-tab" data-bs-toggle="tab" data-bs-target="#mission" type="button"
                  role="tab" aria-controls="mission" aria-selected="true">
                  Mission & Vision
                </button>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <!-- start of main tab content -->
              <div class="tab-pane fade show active" id="main" role="tabpanel" aria-labelledby="main-tab">
                <div class="card">
                  <div class="card-header text-center d-flex" :style="{
                    backgroundColor:
                      this.main_banner.approval === 'Pending'
                        ? '#ffc107'
                        : 'black',
                    padding: '10px',
                    color: 'white',
                  }">
                    <h5 class="flex-grow-1">Banner</h5>
                    <span v-if="this.main_banner.approval === 'Pending'" class="float-right btn bg-secondary"><i
                        class="fa fa-lock text-white"></i></span>
                  </div>
                  <div class="card-body">
                    <div style="display: flex; flex-direction: column">
                      <div style="
                          display: flex;
                          flex-direction: row;
                          align-items: center;
                        ">
                        <img :src="this.main_banner.image_url" style="
                            width: 120px;
                            height: 120px;
                            object-fit: contain;
                            border-radius: 10px;
                            border: dashed 1px gray;
                          " />
                        <div v-if="!isApprover && main_banner.approval !== 'Pending'"
                          class="fileUpload bg-none text-left align-middle d-block">
                          <div>
                            <span class="media-text p-2">Select from Media Library (Max dimension 1200 x
                              800 px)</span>
                          </div>
                          <button @click="openGalleryModal('banner')" aria-hidden="true" class="mx-2 p-2 border w-auto">
                            Browse...
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="float-right">
                      <button @click="mainBannerPreview" class="btn btn-light m-2">
                        Preview
                      </button>
                      <button v-if="!isApprover && this.main_banner.approval !== 'Pending'
                        " @click="mainBannerDraft" class="btn btn-light m-2">
                        Save Draft
                      </button>
                      <button v-if="!isApprover && this.main_banner.approval !== 'Pending'
                        " @click="mainBannerSubmit" class="btn btn-warning m-2">
                        Submit For Approval
                      </button>
                      <button v-if="isApprover && this.main_banner.approval === 'Pending'
                        " data-bs-toggle="modal" data-bs-target="#approveModal"
                        class="btn btn-warning m-2 approveModal" @click="openApprovalModal('banner')">
                        Approval
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-header text-center d-flex" :style="{
                    backgroundColor:
                      this.aboutUs_segment.approval === 'Pending' ||
                        this.history_segment.approval === 'Pending' ||
                        this.milestone_segment.approval === 'Pending' ||
                        this.mission_segment.approval === 'Pending'
                        ? '#ffc107'
                        : 'black',
                    padding: '10px',
                    color: 'white',
                  }">
                    <h5 class="flex-grow-1">Main Segments</h5>
                    <span v-if="this.aboutUs_segment.approval === 'Pending' ||
                      this.history_segment.approval === 'Pending' ||
                      this.milestone_segment.approval === 'Pending' ||
                      this.mission_segment.approval === 'Pending'
                      " class="float-right btn bg-secondary"><i class="fa fa-lock text-white"></i></span>
                  </div>
                  <div class="card-body">
                    <div class="col-lg-12 d-flex">
                      <div class="col-lg-4 b-r-dark">
                        <p>
                          This is the primary section of the About Us page,
                          allowing you to update the image
                        </p>
                        <div class="mt-4 mb-3 main-img"></div>
                      </div>
                      <div class="col-lg-8 p-l-20">
                        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-2 g-5">
                          <div>
                            <p class="fw-bold">1. About Us</p>
                            <div class="">
                              <div style="display: flex; flex-direction: column">
                                <div style="
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;
                                  ">
                                  <img :src="this.aboutUs_segment.image_url
                                    ? this.aboutUs_segment.image_url
                                    : require('@/assets/images/empty.jpg')
                                    " style="
                                      width: 120px;
                                      height: 120px;
                                      object-fit: contain;
                                      border-radius: 10px;
                                      border: dashed 1px gray;
                                    " />
                                  <div v-if="!isApprover && aboutUs_segment.approval !== 'Pending'"
                                    class="fileUpload bg-none text-left align-middle d-block">
                                    <div>
                                      <span class="media-text p-2">Select from Media Library (Max
                                        dimension 1200 x 800 px)</span>
                                    </div>
                                    <button @click="
                                      openGalleryModal('aboutus_segment')
                                      " aria-hidden="true" class="mx-2 p-2 border w-auto">
                                      Browse...
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div>
                            <p class="fw-bold">2. History</p>
                            <div class="">
                              <div style="display: flex; flex-direction: column">
                                <div style="
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;
                                  ">
                                  <img :src="this.history_segment.image_url
                                    ? this.history_segment.image_url
                                    : require('@/assets/images/empty.jpg')
                                    " style="
                                      width: 120px;
                                      height: 120px;
                                      object-fit: contain;
                                      border-radius: 10px;
                                      border: dashed 1px gray;
                                    " />
                                  <div v-if="!isApprover && history_segment.approval !== 'Pending'"
                                    class="fileUpload bg-none text-left align-middle d-block">
                                    <div>
                                      <span class="media-text p-2">Select from Media Library (Max
                                        dimension 1200 x 800 px)</span>
                                    </div>
                                    <button @click="
                                      openGalleryModal('history_segment')
                                      " aria-hidden="true" class="mx-2 p-2 border w-auto">
                                      Browse...
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div>
                            <p class="fw-bold">3. Corporate Milestone</p>
                            <div class="">
                              <div style="display: flex; flex-direction: column">
                                <div style="
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;
                                  ">
                                  <img :src="this.milestone_segment.image_url
                                    ? this.milestone_segment.image_url
                                    : require('@/assets/images/empty.jpg')
                                    " style="
                                      width: 120px;
                                      height: 120px;
                                      object-fit: contain;
                                      border-radius: 10px;
                                      border: dashed 1px gray;
                                    " />
                                  <div v-if="!isApprover && milestone_segment.approval !== 'Pending'"
                                    class="fileUpload bg-none text-left align-middle d-block">
                                    <div>
                                      <span class="media-text p-2">Select from Media Library (Max
                                        dimension 1200 x 800 px)</span>
                                    </div>
                                    <button @click="
                                      openGalleryModal('milestone_segment')
                                      " aria-hidden="true" class="mx-2 p-2 border w-auto">
                                      Browse...
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div>
                            <p class="fw-bold">4. Mission & Vision</p>
                            <div class="">
                              <div style="display: flex; flex-direction: column">
                                <div style="
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;
                                  ">
                                  <img :src="this.mission_segment.image_url
                                    ? this.mission_segment.image_url
                                    : require('@/assets/images/empty.jpg')
                                    " style="
                                      width: 120px;
                                      height: 120px;
                                      object-fit: contain;
                                      border-radius: 10px;
                                      border: dashed 1px gray;
                                    " />
                                  <div v-if="!isApprover && mission_segment.approval !== 'Pending'"
                                    class="fileUpload bg-none text-left align-middle d-block">
                                    <div>
                                      <span class="media-text p-2">Select from Media Library (Max
                                        dimension 1200 x 800 px)</span>
                                    </div>
                                    <button @click="
                                      openGalleryModal('mission_segment')
                                      " aria-hidden="true" class="mx-2 p-2 border w-auto">
                                      Browse...
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="float-right">
                      <button @click="mainSegmentPreview" class="btn btn-light m-2">
                        Preview
                      </button>
                      <button v-if="!isApprover &&
                        (this.aboutUs_segment.approval !== 'Pending' ||
                          this.history_segment.approval !== 'Pending' ||
                          this.milestone_segment.approval !== 'Pending' ||
                          this.mission_segment.approval !== 'Pending')
                        " @click="mainSegmentDraft" class="btn btn-light m-2">
                        Save Draft
                      </button>

                      <button v-if="!isApprover &&
                        (this.aboutUs_segment.approval !== 'Pending' ||
                          this.history_segment.approval !== 'Pending' ||
                          this.milestone_segment.approval !== 'Pending' ||
                          this.mission_segment.approval !== 'Pending')
                        " @click="mainSegmentSubmit" class="btn btn-warning m-2">
                        Submit For Approval
                      </button>
                      <button v-if="isApprover &&
                        (this.aboutUs_segment.approval === 'Pending' ||
                          this.history_segment.approval === 'Pending' ||
                          this.milestone_segment.approval === 'Pending' ||
                          this.mission_segment.approval === 'Pending')
                        " data-bs-toggle="modal" data-bs-target="#approveModal"
                        class="btn btn-warning m-2 approveModal" @click="openApprovalModal('segment')">
                        Approval
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end of main tab content -->

              <!-- start of about tab content -->
              <div class="tab-pane fade" id="about" role="tabpanel" aria-labelledby="about-tab">
                <aboutUsComponent @about_banner="getAboutBanner" @about_approval="getAboutData">
                </aboutUsComponent>
              </div>
              <!-- end of about tab content -->

              <!-- start of history tab content -->
              <div class="tab-pane fade" id="history" role="tabpanel" aria-labelledby="history-tab">
                <historyComponent @history="getHistory" @history_approval="getHistoryData"></historyComponent>
              </div>
              <!-- end of about history content -->

              <!-- start of milestone tab content -->
              <div class="tab-pane fade" id="milestone" role="tabpanel" aria-labelledby="milestone-tab">
                <milestoneComponent @milestone="getMilestone" @milestone_approval="getMilestoneData"></milestoneComponent>
              </div>
              <!-- end of milestone tab content -->

              <!-- start of mission tab content -->
              <div class="tab-pane fade" id="mission" role="tabpanel" aria-labelledby="mission-tab">
                <missionComponent @mission="getMission" @mission_approval="getMissionData"></missionComponent>
              </div>
              <!-- end of mission tab content -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SmallButtonComponent from "@/components/SmallButtonComponent.vue";
import DropFile from "@/components/DropFile.vue";
import TableComponent from "@/components/TableComponent.vue";
import { DataTable, Column } from "primevue/datatable";
import FileUploadComponent from "@/components/FileUploadComponent.vue";
import LastUpdated from "./Faqs/LastUpdated.vue";
import { getRequest, postRequest } from "@/services/RequestService";
import ImageComponent from "@/components/ImageComponent.vue";
import { checkUserRole } from "@/services/Auth.js";
import ApprovalComponent from "@/components/ApprovalComponent.vue";

import aboutUsComponent from "@/components/aboutUs/aboutUs/aboutUsComponent.vue";
import historyComponent from "@/components/aboutUs/history/historyComponent.vue";
import milestoneComponent from "@/components/aboutUs/milestone/milestoneComponent.vue";
import missionComponent from "@/components/aboutUs/mission/missionComponent.vue";
import { nextTick } from "vue";

export default {
  components: {
    SmallButtonComponent,
    DropFile,
    TableComponent,
    DataTable,
    Column,
    ImageComponent,
    FileUploadComponent,
    LastUpdated,
    aboutUsComponent,
    historyComponent,
    milestoneComponent,
    missionComponent,
    ApprovalComponent,
  },

  data() {
    return {
      main_banner: [],
      aboutUs_segment: [],
      history_segment: [],
      milestone_segment: [],
      mission_segment: [],
      isApprover: false,
      datas: null,
      about_banner: [],
      main_segments: [],

      milestone_banner: [],

      // for search purposes
      myTableColumns: [
        { field: "description" },
        { field: "author" },
        { field: "status" },
        { field: "approved_by" },
        { field: "remarks" },
        { field: "statusText" },
      ],
      originalMyTableData: [],
      myTableData: [],

      headerClass: "table-dark",
      activeIndex: null,
      buttons: [
        { id: null, status: true, name: "All" },
        { id: 2, status: false, name: "Approved" },
        { id: 1, status: false, name: "Pending" },
        { id: 4, status: false, name: "Rejected" },
        { id: 3, status: false, name: "Expired" },
      ],
    };
  },

  methods: {
    getClass(status) {
      switch (status) {
        case 2:
          return "text-success";
        case 1:
          return "text-warning";
        case 4:
          return "text-danger";
        case 3:
          return "text-brown";
        default:
          return "text-grey";
      }
    },

    blockStatus(status) {
      switch (status) {
        case 2:
          return "bg-light-success";
        case 1:
          return "bg-light-warning";
        case 4:
          return "bg-light-danger";
        case 3:
          return "bg-light-brown";
        default:
          return "bg-light-dark";
      }
    },

    async getUpdatedData() {
      try {
        const response = await getRequest("/about-us/create");

        if (response.data.success == false) {
          throw new Error("Error encountered. Please try again.");
        }
        this.myTableData = response.data.data.logs;
        this.originalMyTableData = response.data.data.logs;
        this.lastUpdated = response.data.data.last_updated_at;
      } catch (e) {
        swal({
          icon: "error",
          text: e.message,
        });
      }
    },

    async handleClick(type, int) {
      this.buttons.forEach((button) => {
        button.status = int === button.id;
      });

      this.changeFilter(int);
    },

    async changeFilter(id) {
      if (id == null) {
        this.myTableData = this.originalMyTableData;
      } else {
        this.myTableData = this.originalMyTableData.filter(
          (item) => parseInt(item.status) === parseInt(id)
        );
      }
    },

    async loadMain() {
      try {
        let response = await getRequest("/about-us/create?section=1", true);

        if (response.data.success === false) {
          throw new Error("Error encountered. Please try again.");
        }
        this.main_banner = response.data.data.main_banner;
        this.aboutUs_segment = response.data.data.main_segments[0];
        this.history_segment = response.data.data.main_segments[1];
        this.milestone_segment = response.data.data.main_segments[2];
        this.mission_segment = response.data.data.main_segments[3];
        this.main_segments = response.data.data.main_segments;
      } catch (error) {
        console.error("Error fetching API data:", error);
      }
    },

    openGalleryModal(section) {
      console.log("Open Gallery for:", section);

      document.getElementById("modal_id").value = section;

      var galleryModal = document.getElementById("galleryModal");
      galleryModal.classList.add("show");
      galleryModal.style.display = "block";
    },

    handleAddImage(galleryId) {
      console.log(
        "Added image with ID:",
        galleryId,
        "For Section:",
        galleryId.modalName
      );

      if (galleryId.modalName == "banner") {
        this.main_banner.image_url = galleryId.galleryUrl;
        this.main_banner.gallery_id = galleryId.galleryId;
      }
      if (galleryId.modalName == "aboutus_segment") {
        this.aboutUs_segment.image_url = galleryId.galleryUrl;
        this.aboutUs_segment.gallery_id = galleryId.galleryId;
      }
      if (galleryId.modalName == "history_segment") {
        this.history_segment.image_url = galleryId.galleryUrl;
        this.history_segment.gallery_id = galleryId.galleryId;
      }
      if (galleryId.modalName == "milestone_segment") {
        this.milestone_segment.image_url = galleryId.galleryUrl;
        this.milestone_segment.gallery_id = galleryId.galleryId;
      }
      if (galleryId.modalName == "mission_segment") {
        this.mission_segment.image_url = galleryId.galleryUrl;
        this.mission_segment.gallery_id = galleryId.galleryId;
      }

      //about us
      if (galleryId.modalName == "banner_about_us") {
        this.about_banner.image_url = galleryId.galleryUrl;
        this.about_banner.gallery_id = galleryId.galleryId;
      }
      if (galleryId.modalName == "aboutus_image") {
        this.about_image.image_url = galleryId.galleryUrl;
        this.about_image.gallery_id = galleryId.galleryId;
      }

      //history
      if (galleryId.modalName == "history_banner") {
        this.history_banner.image_url = galleryId.galleryUrl;
        this.history_banner.gallery_id = galleryId.galleryId;
      }
      if (galleryId.modalName == "history_image") {
        this.history_image.image_url = galleryId.galleryUrl;
        this.history_image.gallery_id = galleryId.galleryId;
      }

      //milestone
      if (galleryId.modalName == "milestone_banner") {
        this.milestone_banner.image_url = galleryId.galleryUrl;
        this.milestone_banner.gallery_id = galleryId.galleryId;
      }
      if (galleryId.modalName == "milestone_image") {
        this.milestone_description.image_url = galleryId.galleryUrl;
        this.milestone_description.gallery_id = galleryId.galleryId;
      }

      //mission
      if (galleryId.modalName == "mission_banner") {
        this.mission_banner.image_url = galleryId.galleryUrl;
        this.mission_banner.gallery_id = galleryId.galleryId;
      }
      if (galleryId.modalName == "vision") {
        this.mission_vision.image_url = galleryId.galleryUrl;
        this.mission_vision.gallery_id = galleryId.galleryId;
      }
    },

    //all emitted events
    getAboutBanner(val) {
      this.about_banner = val.banner;
      this.about_image = val.image;
    },
    getAboutData(val) {
      this.about_banner = val.banner;
      this.about_image = val.image;
      this.about_description = val.description;
    },
    getHistory(val) {
      this.history_banner = val.banner;
      this.history_image = val.image;
    },
    getHistoryData(val) {
      this.history_banner = val.banner;
      this.history_image = val.image;
      this.history_description = val.description;
    },
    getMilestone(val) {
      this.milestone_banner = val.banner;
      this.milestone_description = val.image;
    },
    getMilestoneData(val) {
      this.milestone_banner = val.banner;
      this.milestone_description = val.description;
    },
    getMission(val) {
      this.mission_banner = val.banner;
      this.mission_vision = val.image;
    },
    getMissionData(val) {
      this.mission_banner = val.banner;
      this.mission_mission = val.mission;
      this.mission_vision = val.vision;
      this.mission_value = val.value;
    },


    //For Approvals
    openApprovalModal(modalName) {
      document.getElementById("data_id").value = modalName;
    },

    handleData(entityData) {

      //About Us Main
      if (entityData.dataName === "banner") {
        this.datas = this.main_banner;
      }
      if (entityData.dataName === "segment") {
        this.datas = this.aboutUs_segment;
        this.datas = this.history_segment;
        this.datas = this.milestone_segment;
        this.datas = this.mission_segment;
      }

      //About Us
      if (entityData.dataName === "aboutus_banner") {
        this.datas = this.about_banner;
      }
      if (entityData.dataName === "aboutus_image") {
        this.datas = this.about_image;
      }
      if (entityData.dataName === "about_description") {
        this.datas = this.about_description;
      }

      //History
      if (entityData.dataName === "history_banner") {
        this.datas = this.history_banner;
      }
      if (entityData.dataName === "history_image") {
        this.datas = this.history_image;
      }
      if (entityData.dataName === "history_description") {
        this.datas = this.history_description;
      }

      //Milestone
      if (entityData.dataName === "milestone_banner") {
        this.datas = this.milestone_banner;
      }

      if (entityData.dataName === "milestone_image") {
        this.datas = this.milestone_description;
      }

      //Mission Vision
      if (entityData.dataName === "mission_banner") {
        this.datas = this.mission_banner;
      }
      if (entityData.dataName === "mission_mission") {
        this.datas = this.mission_mission;
      }
      if (entityData.dataName === "mission_vision") {
        this.datas = this.mission_vision;
      }
      if (entityData.dataName === "mission_values") {
        this.datas = this.mission_value;
      }

    },



    //Banner Section
    async mainBannerPreview() {
      if (this.main_banner.approval == 'Pending' || (this.main_banner.approval == 'Approved' && this.isApprover)) {
        window.open("/about-us-main?preview=1");
      } else {
        let postData = {
          image: this.main_banner.gallery_id
            ? this.main_banner.gallery_id
            : this.main_banner.image_id,
          approval: false,
        };

        let response;

        if (this.main_banner.approval === "Draft") {
          response = await postRequest(
            "/about-us/main/" + this.main_banner.id,
            postData
          );
        } else {
          response = await postRequest("/about-us/main", postData);
        }

        if (response.data.success) {
          window.open("/about-us-main?preview=1", "_blank");
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }
      }
    },
    mainBannerDraft() {
      this.bannerSubmission(this.main_banner, 0);
    },
    mainBannerSubmit() {
      this.bannerSubmission(this.main_banner, 1);
    },

    async bannerSubmission(data, approval) {
      try {
        let post_request = this._bannerRequest(data);
        post_request.approval = approval;

        let response;

        if (this.main_banner.approval === "Draft") {
          response = await postRequest(
            "/about-us/main/" + this.main_banner.id,
            post_request
          );
        } else {
          response = await postRequest("/about-us/main", post_request);
        }

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            location.reload();
          });
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        if (response.data.success === false) {
          throw new Error("Something's not right. Please try again.");
        }

        console.log(response.data);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    _bannerRequest(data) {
      return {
        image: this.main_banner.gallery_id
          ? this.main_banner.gallery_id
          : this.main_banner.image_id,
        status: 0,
      };
    },

    //Main Segment Section
    async mainSegmentPreview() {
      if (
        this.aboutUs_segment.approval == "Pending" ||
        this.history_segment.approval == "Pending" ||
        this.milestone_segment.approval == "Pending" ||
        this.mission_segment.approval == "Pending" ||
        ((this.aboutUs_segment.approval == "Approved" ||
          this.history_segment.approval == "Approved" ||
          this.milestone_segment.approval == "Approved" ||
          this.mission_segment.approval == "Approved") && this.isApprover)
      ) {
        window.open("/about-us-main?preview=1", "_blank");
      } else {
        let postData = {
          image_about_us: this.aboutUs_segment.gallery_id
            ? this.aboutUs_segment.gallery_id
            : this.aboutUs_segment.image_id,
          image_history: this.history_segment.gallery_id
            ? this.history_segment.gallery_id
            : this.history_segment.image_id,
          image_corporate_milestone: this.milestone_segment.gallery_id
            ? this.milestone_segment.gallery_id
            : this.milestone_segment.image_id,
          image_mission_vision: this.mission_segment.gallery_id
            ? this.mission_segment.gallery_id
            : this.mission_segment.image_id,
          approval: false,
        };

        let response;

        if (this.aboutUs_segment.approval === "Draft") {
          // this.main_segments.map(async (main, index) => {
          response = await postRequest(
            "/about-us/main_segment/" + this.aboutUs_segment.id,
            postData
          );
          // });
        } else {
          response = await postRequest("/about-us/main_segment", postData);
        }

        if (response.data.success) {
          window.open("/about-us-main?preview=1", "_blank");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }
      }
    },
    mainSegmentDraft() {
      this.mainSegmentSubmission(0);
    },
    mainSegmentSubmit() {
      this.mainSegmentSubmission(1);
    },

    async mainSegmentSubmission(approval) {
      try {
        let post_request = this._segmentRequest();
        post_request.approval = approval;

        let response;

        if (this.aboutUs_segment.approval === "Draft") {
          // this.main_segments.map(async (main, index) => {
          response = await postRequest(
            "/about-us/main_segment/" + this.aboutUs_segment.id,
            post_request
          );
          // });
        } else {
          response = await postRequest("/about-us/main_segment", post_request);
        }

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            location.reload();
          });
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        if (response.data.success === false) {
          throw new Error("Something's not right. Please try again.");
        }

        console.log(response.data);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    _segmentRequest() {
      return {
        image_about_us: this.aboutUs_segment.gallery_id
          ? this.aboutUs_segment.gallery_id
          : this.aboutUs_segment.image_id,
        image_history: this.history_segment.gallery_id
          ? this.history_segment.gallery_id
          : this.history_segment.image_id,
        image_corporate_milestone: this.milestone_segment.gallery_id
          ? this.milestone_segment.gallery_id
          : this.milestone_segment.image_id,
        image_mission_vision: this.mission_segment.gallery_id
          ? this.mission_segment.gallery_id
          : this.mission_segment.image_id,
        status: 0,
      };
    },

    async checkUserRole() {
      this.isApprover = await checkUserRole();
    },
  },

  async mounted() {
    this.checkUserRole();
    await this.loadMain();
    await this.getUpdatedData();
  },
};
</script>

<style scoped>
.nav-link.active {
  background-color: #ffbc0d !important;
  font-weight: bolder !important;
}

.main-img {
  height: 20rem;
  background-image: url("@/assets/images/admin/about-us/Main.svg");
  background-size: 80%;
}</style>
